import { useState } from "react";
import { Images } from "../constants";

export default () => {
  let toastProperties = null;
  const [ toastList, setToastList ] = useState([]);
  const [ autoDeleteTime ] = useState(0);
  const [ position, setPostion ] = useState('bottom-left');
  const [ autoDelete, setAutoDelete ] = useState(true);
  const [ dismissTime, setDismissTime ] = useState(3000);

  const showToast = (type, message) => {
    const id = Math.floor((Math.random() * 101) + 1);

    switch(type) {
      case 'success':
        toastProperties = {
          id,
          title: 'Success',
          description: message,
          backgroundColor: '#5cb85c',
          icon: Images.checkIcon
        }
        break;
      case 'danger':
        toastProperties = {
          id,
          title: 'Danger',
          description: message,
          backgroundColor: '#d9534f',
          icon: Images.errorIcon
        }
        break;
      case 'info':
        toastProperties = {
          id,
          title: 'Info',
          description: message,
          backgroundColor: '#5bc0de',
          icon: Images.infoIcon
        }
        break;
      case 'warning':
        toastProperties = {
          id,
          title: 'Warning',
          description: message,
          backgroundColor: '#f0ad4e',
          icon: Images.warningIcon
        }
        break;

        default:
          setToastList([]);
    }

    setToastList([...toastList, toastProperties]);
  };

  const showError = (message = false, position = false, autoDelete = false, dismissTime = false) => {
    if(message) showToast('danger', message);
    if(position) setPostion(position);
    if(autoDelete) setAutoDelete(autoDelete);
    if(dismissTime) setDismissTime(dismissTime)
  }
  return { toastList, toastProperties, autoDeleteTime, showError, position, autoDelete, dismissTime, showToast };
};
